import React, { useEffect, useState, useCallback, ChangeEvent } from "react";
import { Button, Card, MenuItem, useTheme } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "src/store/Store";
import { PageContainer, Breadcrumb } from "../common";
import Loading from "../common/Loading";
import { selectUserCompany } from "src/store/authSlice";
import { client } from "src/common/axiosClient";
import Modal from "../common/Modal";
import { useNavigate } from "react-router";
import moment from "moment";

export default function MaunalTheraistReservation() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [hosting, setHosting] = useState("ALL");

  // 라디오 버튼 선택 시 상태를 업데이트하는 함수입니다.
  const handleChange = (e: any) => {
    setHosting(e.target.value);
  };

  const borderColor = theme.palette.divider;

  const [isLoding, setLoding] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [pageListSize, setPageListSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);
  const [startIndex, setStartIndex] = useState<number>(0);
  const [endIndex, setEndIndex] = useState<number>(0);

  useEffect(() => {
    getReservationList();
  }, []);
  useEffect(() => {
    getReservationList();
  }, [currentPage]);

  useEffect(() => {
    setPageNumbers([]);
    let pageNumbersArr = [];
    //페이지 리스트 계산
    for (let i: number = 1; i <= totalPages; i++) {
      pageNumbersArr.push(i);
    }
    setPageNumbers(pageNumbersArr);
    // 현재 페이지 리스트의 시작과 끝 계산
    const startIndex =
      (Math.ceil(currentPage / pageListSize) - 1) * pageListSize + 1;
    const endIndex = Math.min(startIndex + pageListSize - 1, totalPages);
    setStartIndex(startIndex);
    setEndIndex(endIndex);
  }, [totalPages]);

  const getReservationList = async () => {
    setData([]);
    const response = await client.get(
      `/admin/api/v1/reservation/MANUAL_THERAPIST?page=${currentPage}&perPage=${pageListSize}`,
      {}
    );
    if (response.status === 200) {
      console.log(response);
      setData([...response.data.content]);
      setTotalPages(response.data.paging.totalPage);
    } else {
      console.log(response);
    }
  };

  // 페이지 이동 함수
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
  const goToPrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const reservationVisit = async (id: number) => {
    const response = await client.put(
      `admin/api/v1/reservation/MANUAL_THERAPIST/${id}/visit`
    );
    if (response.status === 200) {
      console.log(response);
      getReservationList();
    } else {
      console.log(response);
    }
  };

  const reservationNoshow = async (id: number) => {
    const response = await client.put(
      `admin/api/v1/reservation/MANUAL_THERAPIST/${id}/no-show`
    );
    if (response.status === 200) {
      console.log(response);
      getReservationList();
    } else {
      console.log(response);
    }
  };

  const reservationDelete = async (id: number) => {
    const response = await client.delete(
      `admin/api/v1/reservation/MANUAL_THERAPIST/${id}`
    );
    if (response.status === 200) {
      console.log(response);
      getReservationList();
    } else {
      console.log(response);
    }
  };

  //의사등록
  const [isInsertShow, setIsInsertShow] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const [file, setFile] = useState<any>(null);

  //의사 수정
  const [isUpdateShow, setIsUpdateShow] = useState<boolean>(false);
  const [nameUpdate, setNameUpdate] = useState<string>("");
  const [choiceDoctorId, setChoiceDoctorId] = useState<number>(0);
  const [previewUrlUpdate, setPreviewUrlUpdate] = useState<any>(null);
  const [fileUpdate, setFileUpdate] = useState<any>(null);

  //의사 이름
  const nameOnChange = (e: any) => {
    setName(e.target.value);
  };
  //의사 이름 수정
  const nameUpdateOnChange = (e: any) => {
    setNameUpdate(e.target.value);
  };

  const getDoctorList = async () => {
    setData([]);
    const response = await client.get("admin/api/v1/doctor/list/all", {});
    if (response.status === 200) {
      console.log(response);
      setData([...response.data.content]);
    } else {
      console.log(response);
    }
  };

  const doDelete = (id: number, index: number) => {
    console.log("aaaa");
  };

  //의사 등록
  // 의사 미리보기
  const fileChangedHandler = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //의사 모달창 닫기
  const setInsertShowModal = (value: boolean) => {
    if (value) {
      setIsInsertShow(value);
    } else {
      setIsInsertShow(value);
      setName("");
      setPreviewUrl(null);
      setFile(null);
      getDoctorList();
    }
  };
  //의사 모달창 닫기
  const insertDoctor = async () => {
    if (name !== "" && previewUrl !== "") {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("profileImageFile", file);

      const response = await client.post("admin/api/v1/doctor", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 201) {
        alert("의사등록이 완료되었습니다.");
        setInsertShowModal(false);
      }
    } else {
      alert("값을 입력해주세요");
    }
  };

  return (
    <>
      <PageContainer>
        <Loading isLoading={isLoding} />
        <Breadcrumb
          action={
            <div className="space-x-5">
              {/* <Button
                variant="contained"
                size="small"
                onClick={() => setInsertShowModal(true)}
              >
                의사추가
              </Button> */}
            </div>
          }
        >
          <div className="flex items-center">
            <div>환자 예약 관리</div>
          </div>
        </Breadcrumb>
        <Card sx={{ padding: "10px", border: `1px solid ${borderColor}` }}>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500 ">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    담당원장
                  </th>
                  <th scope="col" className="px-6 py-3">
                    환자이름/진료상태
                  </th>
                  <th scope="col" className="px-6 py-3">
                    예약날짜
                  </th>
                  <th scope="col" className="px-6 py-3">
                    환자 전화번호
                  </th>
                  <th scope="col" className="px-6 py-3">
                    환자성별
                  </th>
                  <th scope="col" className="px-6 py-3">
                    방문한 날짜
                  </th>
                  <th scope="col" className="px-6 py-3">
                    삭제처리
                  </th>
                  <th scope="col" className="px-6 py-3">
                    미방문처리
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  //  {id:1, status:'대기', dayStatus:'경고', dDay:10, backgroundColor:'#D1T32'},
                  return (
                    <tr
                      key={index}
                      className="bg-white border-b  hover:bg-gray-50 "
                    >
                      <td className="w-32 p-4">
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                          {item.medicalStaff?.name
                            ? item.medicalStaff.name
                            : "-"}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        {item.patient?.name ? item.patient.name : "-"}(
                        {item.patient?.birthDate ? item.patient.birthDate : ""})
                        {item.visitStatus === "FOLLOW_UP" ? (
                          <span className="bg-green-200 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                            재진
                          </span>
                        ) : (
                          <span className="bg-yellow-200 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                            초진
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {item.reservedAt
                          ? moment(item.reservedAt).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </td>
                      <td className="px-6 py-4">
                        {item.patient?.mobile ? item.patient.mobile : "-"}
                      </td>
                      <td className="px-6 py-4">
                        {item.patient?.gender === "MALE" ? (
                          <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                            남자
                          </span>
                        ) : (
                          <span className="bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                            여자
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4 text-center">
                        {item.visitedAt ? (
                          moment(item.visitedAt).format("YYYY-MM-DD HH:mm")
                        ) : item.deletedAt == null ? (
                          <button
                            type="button"
                            className="focus:outline-none text-white bg-orange-500 hover:bg-orange-600 focus:ring-4 focus:ring-orange-300 font-medium rounded-lg text-sm px-2 py-1.5 me-2 mb-1 "
                            onClick={() => reservationVisit(item.id)}
                          >
                            방문처리
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {item.deletedAt ? (
                          <button
                            type="button"
                            className="focus:outline-none text-white bg-gray-400 hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-2 py-1.5 me-2 mb-1 "
                          >
                            삭제완료
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="focus:outline-none text-white bg-red-500 hover:bg-red-600 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-2 py-1.5 me-2 mb-1 "
                            onClick={() => reservationDelete(item.id)}
                          >
                            삭제처리
                          </button>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          type="button"
                          className="focus:outline-none text-white bg-orange-500 hover:bg-orange-600 focus:ring-4 focus:ring-orange-300 font-medium rounded-lg text-sm px-2 py-1.5 me-2 mb-1 "
                          onClick={() => reservationDelete(item.id)}
                        >
                          미방문처리
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* 페이지 */}
          <nav aria-label="Page navigation example" className="mt-5">
            <ul className="inline-flex -space-x-px text-sm">
              {/* 이전 페이지 */}
              <li>
                <button
                  onClick={goToPrevPage}
                  className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 "
                >
                  Previous
                </button>
              </li>
              {/* 페이지 번호 */}
              {pageNumbers.map((number) => (
                <li key={number}>
                  <button
                    onClick={() => paginate(number)}
                    className={`flex items-center justify-center px-3 h-8 leading-tight ${
                      currentPage === number
                        ? "text-blue-600 border border-gray-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                        : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                    } `}
                  >
                    {number}
                  </button>
                </li>
              ))}
              {/* 다음 페이지 */}
              <li>
                <button
                  onClick={goToNextPage}
                  className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 "
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </Card>
      </PageContainer>
    </>
  );
}
